
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ultimate_coaching_trip/[locale]/closed",
      function () {
        return require("private-next-pages/ultimate_coaching_trip/[locale]/closed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ultimate_coaching_trip/[locale]/closed"])
      });
    }
  